export function groupEventListener(event, selector, callback) {
	for (let i = 0; i < selector.length; i++) {
		selector[i].addEventListener(event, callback);
	}
}
export function getPreviousSibling(elem, selector) {
	// Get the next sibling element
	let sibling = elem.previousElementSibling; // If there's no selector, return the first sibling

	if (!selector) return sibling; // If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop

	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.previousElementSibling;
	}
}

export function classChain(elt) {
	const list = elt.classList;
	return {
		toggle: function toggle(c) {
			list.toggle(c);
			return this;
		},
		add: function add(c) {
			list.add(c);
			return this;
		},
		remove: function remove(c) {
			list.remove(c);
			return this;
		},
	};
}
export function isInViewport(elem) {
	const bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <=
			(window.innerWidth || document.documentElement.clientWidth)
	);
}

export function isOutOfViewport(elem) {
	// Get element's bounding
	const bounding = elem.getBoundingClientRect(); // Check if it's out of the viewport on each side

	const out = {};
	out.top = bounding.top < 0;
	out.left = bounding.left < 0;
	out.bottom =
		bounding.bottom >
		(window.innerHeight || document.documentElement.clientHeight);
	out.right =
		bounding.right >
		(window.innerWidth || document.documentElement.clientWidth);
	out.any = out.top || out.left || out.bottom || out.right;
	out.all = out.top && out.left && out.bottom && out.right;
	return out;
}
